import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonMenuButton,
  IonContent,
} from '@ionic/react';
import MessagesContent from '../components/MessagesContent';

const Messages: React.FC = () => (
  <IonPage>
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton menu="main-menu" />
        </IonButtons>
        <IonTitle>Messages</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent fullscreen className="bg-gray-50 dark:bg-gray-900">
      <MessagesContent />
    </IonContent>
  </IonPage>
);

export default Messages;
